module.exports = __webpack_public_path__ + "static/media/registration-left-img.e6409b21.svg";